<script>
import { notify } from '@/helpers/notify' 
import {
  required
} from "vuelidate/lib/validators";

export default {
    name: 'FreezeModal',
    props:[
        "data",
    ],
    data() {
        return {
            routerList: [],
            form: {
                cause:1
            },
            causes:[
                {id:1,title:"Kendi İsteği İle"},
                {id:2,title:"Muhasebe tarafından"},
                {id:3,title:"Teknik Sebeplerden"},
            ],
            submitted: false,
        };
    },  
    computed:{
        modalTitle(){ return this.form.direction == 1 ? "Dondurma" : "Çöz" }
    },
    watch:{
        data(props){
            this.form = {...props}
        }
    },
    validations: {
        form: {  
            cause: { required },
        },
    },
    methods: {
        close(){
            this.$parent.$bvModal.hide('freeze_modal')
        },
        handleSubmit(){
            this.$http.put('/members/kb_update', { cause:this.form.cause, direction:this.form.direction, id:this.form.id })
                    .then(resp => { 
                        notify.success(resp.data.message)
                    })
                    .catch(error => error)
        }
    },
};
</script>

<template>
<b-modal id="freeze_modal"  :title="modalTitle"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
        <div class="row">
            <div class="col-md-12">
                 <div class="alert alert-warning">
                    {{ form.fname }}
                    {{ form.lname }}
                    <br>
                    {{ form.username}}
                </div>
            </div>
        </div>  
        <div class="row d-flex flex-wrap mb-1" v-if="form.direction == 1">
            <label class="col-sm-5 col-form-label col-form-label" for="cause">Dondurulma Sebebi</label>
            <div class="col">
            <select class="form-select" v-model="form.cause">
                <option :value="cause.id" v-for="cause in causes" :key="cause.id">{{ cause.title }} </option>
            </select>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <b-button variant="light" @click="close()">Vazgeç</b-button>
            <b-button 
                v-if="form.direction == 1"
                type="submit" 
                variant="warning" 
                class="ms-1"
                >Dondur
            </b-button>
            <b-button 
                v-else
                type="submit" 
                variant="success" 
                class="ms-1"
                >Çöz
            </b-button>
        </div>
    </form>
</b-modal>
</template>